<template>
  <v-dialog max-width="600px" v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" class="success mx-1" @click="getCartAddress"
        ><v-icon>email</v-icon><span>Order Address</span></v-btn
      ></template
    >
    <v-card>
      <v-card-title>
        <h2>Order Address</h2>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3" ref="form">
          <v-textarea
            v-model="cartAddress"
            label="Address"
            prepend-icon="email"
            disabled
            auto-grow
          ></v-textarea>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog" class="success mx-1 mt-3">Close</v-btn>
          <v-btn @click="copyAddress" class="success mx-1 mt-3">Copy</v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import cartApi from "../modules/cart-api";

export default {
  props: {
    cartId: {
      type: String,
    },
  },
  data() {
    return {
      cartAddress: "",
      dialog: false,
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    async getCartAddress() {
      let tmpAddress = await cartApi.getCartAddress(this.cartId);
      this.cartAddress = this.prepareAddress(tmpAddress);
    },
    async copyAddress() {
      let copyRes = false;
      await navigator.clipboard.writeText(this.cartAddress).then(function() {
        copyRes = true;
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
      if (copyRes) this.$toast("Copied address");
      this.dialog = false;
    },
    prepareAddress(address) {
      let updatedAddress = address.replace(/<br>/g, "\n");
      updatedAddress = updatedAddress + "\n\n";
      return updatedAddress;
    },
  },
};
</script>
